import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (param) {
  const { data, isLoading, exec } = useRequest({
    name: 'GET_ENERGY_DEVICES_LIST',
    url: ``,
    method: 'GET',
  });

  useEffect(() => {
    if (param && JSON.stringify(param) !== '{}') {
      let url = '/api/energe/energedevice';
      let arr = [];
      Object.keys(param).forEach(key => {
        arr.push(key + '=' + param[key]);
      });
      if (arr.length !== 0) {
        url += '?' + arr.join('&');
      }
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [data || {}, isLoading, exec];
});
